export default __webpack_public_path__ + "static/media/Not.b90b3013.png";